import { IComponentOptions } from 'angular';
import { PriorityGroupTransferCtrl } from './priority-group-transfer.controller';

export const PriorityGroupStepTransferComponent: IComponentOptions = {
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  controller: PriorityGroupTransferCtrl,
  template: require('./priority-group-transfer.html'),
};
